import { computed, Injectable } from '@angular/core';
import { menuItems, navigateFn } from '@softline/application';
import { authorizationFn } from '@softline/auth';
import { SOFTLINE_PERMISSION_BUCHUNGSBRIEF } from '../buchungsbrief.shared';
import { GesamtabfrageListAddOn } from '@softapps/wws/gesamtabfrage/api';

@Injectable()
export class BuchungsbriefGesamtabfrageListAddOn extends GesamtabfrageListAddOn{

  private isAuthorized = authorizationFn();
  private navigate = navigateFn();

  constructor() {
    super();
    menuItems(() => {
      const hostParams = this.hostParams()
      if(!hostParams
        || hostParams.belegart()?.name !== 'Rechnungsprüfung'
        || !this.isAuthorized(SOFTLINE_PERMISSION_BUCHUNGSBRIEF)())
        return []

      return [{
        type: 'execute',
        name: '#BUCHUNGSBRIEF.ADD_ON.TITLE',
        title: '#BUCHUNGSBRIEF.ADD_ON.TITLE',
        icon: 'fa-regular fa-envelope-open-text',
        outlet: 'action',
        canExecute: computed(() => {
          const selected = hostParams.selected();
          return selected.length === 1
            && (selected[0] as any).kzbelegart !== 'T'
            && (selected[0] as any).kzbelegart !== 'U';
        }),
        execute: async () => {
          const selected = hostParams.selected();
          if (selected.length !== 1)
            return;
          const beleg = selected[0];
          await this.navigate(['/buchungsbrief', beleg.id], {origin: true})
        }
      }]
    })
  }
}
